import * as types from './actionTypes';
// import api from '../../../api/mock';
import api from '../../../api/';

export function getData(cityName) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const cities = await api.getAharaCities();
      const mostExplored = await api.getExperiences();
      const localExperiences = await api.getExperiences();
      // const topRead = await api.getPicks();
      // const topExperiences = await api.getExperiences();
      const topExperiences = await api.getExperiences(cityName);
      dispatch({
        type: types.LOADED,
        cities,
        mostExplored: mostExplored.content,
        localExperiences: localExperiences.content,
        // topRead: topRead.content,
        // topExperiences: topExperiences.content,
        topExperiences,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
